import React, { useState, useEffect } from 'react';
import { 
  CssBaseline, 
  Container, 
  Typography, 
  Box, 
  Button, 
  Grid, 
  Stepper, 
  Step, 
  StepLabel, 
  TextField,
  Link,

} from '@mui/material';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { footerLinks } from '../Shared/footerLinks';
import { config } from '../../../config/settings.jsx';
import { steps } from '../../../config/steps';
import { api } from '../../../config/apis.jsx';
import { getTheme } from '../../../config/theme';
import { useFormik } from 'formik';
import * as yup from 'yup';


const DebtSource = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingYes, setIsLoadingYes] = useState(false);
  const [isLoadingNo, setIsLoadingNo] = useState(false);
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useState('Add Debt Account');
  const cdrid = localStorage.getItem('cdrid');
  const [stepperStep, setStepperStep] = useState(4);
  const [isLoadingSavings, setIsLoadingSavings] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { accounts } = location.state || {};
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [selectedAccountObjectId, setSelectedAccountObjectId] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [accountName, setAccountName] = useState('');
  const [bsb, setBsb] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  

  const validationSchema = yup.object({
    accountName: yup.string().required('Account name is required'),
    bsb: yup.string().matches(/^\d{6}$/, 'BSB must be 6 numbers').required('BSB is required'),
    accountNumber: yup.string().matches(/^\d{8,12}$/, 'Account number must be 8-12 numbers').required('Account number is required'),
     });


  const formik = useFormik({
    initialValues: {
      accountName: '',
      bsb: '',
      accountNumber: '',
    },
    validationSchema: validationSchema,
       onSubmit: async (values) => {
       setIsLoading(true);
      try {
      
        const response = await axios.post(api.submitSavingsAccount, {cdrid, values},
          { headers: { 'Content-Type': 'application/json',
            apikey: config.apikey,
            tenant: config.tenant
           } }
        );
        
        setOpen(false);
        navigate('/finished');

      }  catch (error) {
        console.error('Error registering user:', error);
        setMessage('Failed to register. Please try again.');
      }
    },
  });



return (
    <ThemeProvider theme={getTheme}>
    <CssBaseline>
    <Container component="main" maxWidth="xs">
  
      <Box display="flex" flexDirection="column" alignItems="center" mt={4} p={2} >
      <Grid container justifyContent="center" mb={2}>
         <Box display="flex" flexDirection="column" alignItems="center" mt={4} mb={6} style={{ width: '100%'}} >
        <Stepper activeStep={stepperStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
        </Box>
      
      <Typography variant="h4" component="h2" align="center" mt={2} sx={{fontWeight: 'bold'}} gutterBottom>
      {pageTitle}
      </Typography>
      
      <Box display="flex" flexDirection="column" alignItems="center" mt={4} mb={6} style={{ width: '100%'}}>
  
      <Typography variant="body2" component="h2" align="center" >
     Add your debt source BSB and Account Number and we will make regular repayments to your debt on your behalf
      </Typography>
      </Box>

  
      <Typography variant="body2" component="h2" align="center"  gutterBottom sx={{mb: 4}}>
    Prefer to use Dwindl to save? Add a nominated savings account instead
      </Typography>
    
     <Box>
           <form onSubmit={formik.handleSubmit}>
          <TextField
              fullWidth
              id="accountName"
              name="accountName"
              label="Account Name"
              value={formik.values.accountName}
              onChange={formik.handleChange}
              error={formik.touched.accountName && Boolean(formik.errors.accountName)}
              helperText={formik.touched.accountName && formik.errors.accountName}
              required
              variant="outlined"
              sx={{ '& .MuiOutlinedInput-root': {borderRadius: '30px',  height: '45px', mt: '3px', mb: '3px'}, }}
              />
                         <Box display="flex" width="100%" justifyContent="space-between">
           <Box display="flex"  width="30%" >
            <TextField
              fullWidth
              id="bsb"
              name="bsb"
              label="BSB"
              value={formik.values.bsb}
              onChange={formik.handleChange}
              error={formik.touched.bsb && Boolean(formik.errors.bsb)}
              helperText={formik.touched.bsb && formik.errors.bsb}
              required
              variant="outlined"
              sx={{ '& .MuiOutlinedInput-root': {borderRadius: '30px',  height: '45px', mt: '3px', mb: '3px'}, }}
              />
          </Box>
          <Box display="flex" width="69%" >
            <TextField
              fullWidth
              id="accountNumber"
              name="accountNumber"
              label="Account Number"
              value={formik.values.accountNumber}
              onChange={formik.handleChange}
              error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
              helperText={formik.touched.accountNumber && formik.errors.accountNumber}
              required
              variant="outlined"
              sx={{ '& .MuiOutlinedInput-root': {borderRadius: '30px',  height: '45px', mt: '3px', mb: '3px'}, }}
              />
          </Box></Box>

        
           <Box display="flex"  width="100%" >
           <Button
            type="submit"
            fullWidth
            variant="contained"
            color="switchColor"
            sx={{ mt: 3, mb: 2, borderRadius: "30px", backgroundColor: '#7ac2bb', width: '100%' }}
            disabled={isLoadingSavings}
          >
            <Typography >
            {isLoadingSavings ? 'Loading...' : 'CONTINUE'}
            </Typography>
         
          </Button>

           </Box>
     

          </form>

        </Box>
      
    
      </Grid>
      



                    
      {footerLinks}
        </Box>
    </Container>
    </CssBaseline> </ThemeProvider>
  );
};

export default DebtSource;

export {};